import tippy from 'tippy.js'

const MODAL_TOOLTIP_Z_INDEX = 2147483647

const getScrollParents = (element) => {
  const parents = []
  let node = element?.parentElement

  while (node && node !== document.body) {
    const { overflow, overflowY, overflowX } = getComputedStyle(node)
    const scrollable = /(auto|scroll|overlay)/.test(
      overflow + overflowY + overflowX
    )
    if (scrollable) parents.push(node)
    node = node.parentElement
  }

  parents.push(window)
  return parents
}

class TooltipWrapper extends window.HTMLElement {
  connectedCallback() {
    const button = this.querySelector('button')
    if (!button) return

    // Opt-in: dismiss on outside click and on page scroll. Defaults preserve the
    // original behaviour so existing tooltips (price, reviews) are unaffected.
    const dismissOnInteract = this.getAttribute('data-hide-on-click') === 'true'
    let onScroll = null
    let scrollParents = []

    const instance = tippy(button, {
      placement: this.getAttribute('data-placement') || 'top',
      theme: this.getAttribute('data-dark-mode') === 'true' ? 'dark' : '',
      interactive: true,
      content: `${this.getAttribute('data-content')}`,
      allowHTML: true,
      trigger: 'mouseenter click',
      hideOnClick: dismissOnInteract ? true : 'toggle',
      ...(dismissOnInteract && {
        appendTo: () => document.body,
        zIndex: MODAL_TOOLTIP_Z_INDEX,
        popperOptions: {
          strategy: 'fixed',
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
                altAxis: true,
                padding: 8,
              },
            },
            {
              name: 'flip',
              options: {
                fallbackPlacements: [
                  'bottom-start',
                  'top-start',
                  'bottom',
                  'top',
                ],
              },
            },
          ],
        },
        onShow: () => {
          button.setAttribute('aria-expanded', 'true')
          requestAnimationFrame(() => {
            instance.popperInstance?.update()
          })

          onScroll = () => instance.hide()
          scrollParents = getScrollParents(button)
          for (const parent of scrollParents) {
            parent.addEventListener('scroll', onScroll, { passive: true })
          }
        },
        onHide: () => {
          button.setAttribute('aria-expanded', 'false')
          for (const parent of scrollParents) {
            parent.removeEventListener('scroll', onScroll)
          }
          scrollParents = []
        },
      }),
    })
  }
}

window.customElements.define('tooltip-wrapper', TooltipWrapper)
